import React, { ReactNode } from 'react';
import { withRouter } from 'react-router';
import { WprBaseRouteViewComponent } from '../../wpr-framework/view/component/WprBaseRouteViewComponent';
import { HeaderComponent } from '../common/header/HeaderComponent';
import { FooterComponent } from '../common/footer/FooterComponent';
import { SettlementComponentView } from './SettlementComponentView';

/**
 * メール送信完了コンポーネント
 */
class SettlementComponent extends WprBaseRouteViewComponent {
	// コンストラクタ  -----------------------------------------------------------
	constructor(props: any) {
		super(new SettlementComponentView(), props);
	}
	// --------------------------------------------------------------------------

	// override メソッド  --------------------------------------------------------
	/**
     * 描画
     */
	public onRender(): ReactNode {
		return (
			<>
				<HeaderComponent />
				<br></br>
				<br></br>
				<br></br>
				<br></br>
				<br></br>
				<br></br>
				<br></br>
				<FooterComponent />
			</>
		);
	}
	// --------------------------------------------------------------------------
}

export default withRouter(SettlementComponent);